import { API_ADMIN_PATHS, HMI_PATHS, LocalStorageGlobalKeys } from "constants/constants";
import { ClusterCachedDataContext } from "contexts/ClusterCachedDataContext/ClusterCachedDataContext";
import { HMICachedDataContext } from "contexts/HMICachedDataContext/HMICachedDataContext";
import { useContext } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { isTokenAvailable, resetLocalStorage } from "utilities/storageUtilities";
import { isApiAdministrator } from "utilities/utilities";

export const ProtectedHMIRoute = ({
    redirectPath = `/${HMI_PATHS.ROOT_PATH}/${HMI_PATHS.LOGIN}`,
}: {
    redirectPath?: string;
}) => {
    const token = isTokenAvailable();
    const location = useLocation();
    const {
        store: { machineCenter },
    } = useContext(HMICachedDataContext);
    const {
        store: { machineCentersCluster },
    } = useContext(ClusterCachedDataContext);

    if (!token) {
        return <Navigate to={redirectPath} replace />;
    }
    // OS-2557: confine the API Administrator to its portal. Hasura denies every HMI read under the
    // role, so the shell would otherwise mount and render empty rather than redirecting.
    if (isApiAdministrator()) {
        return <Navigate to={`/${API_ADMIN_PATHS.ROOT_PATH}/${API_ADMIN_PATHS.KEYS}`} replace />;
    }
    if (location.pathname.toLowerCase().includes(`/${HMI_PATHS.ROOT_PATH.toLowerCase()}/${HMI_PATHS.CLUSTER}`)) {
        if (
            (machineCenter || machineCentersCluster[0]) &&
            !(
                machineCenter?.production_line.mill?.cluster_enabled ||
                machineCentersCluster[0]?.production_line?.mill?.cluster_enabled
            )
        ) {
            resetLocalStorage([LocalStorageGlobalKeys.LANGUAGES, LocalStorageGlobalKeys.I18_LANGUAGE_SELECTION]);
            return <Navigate to={redirectPath} replace />;
        }
    }

    return <Outlet />;
};
